import {useIsDesktop} from '@eCommerce/frontend-legacy-shared-library-native';
import {Flex, View} from 'native-base';
import React from 'react';

import SecurityMask from 'components/SecurityMask';

const GatedCityStateZip = () => {
  const isDesktop = useIsDesktop();

  return (
    <View width="100%">
      {!isDesktop && (
        <View mb={isDesktop ? '40px' : 4} flexGrow={1} width="80%">
          <SecurityMask title="City" showAsterisk />
        </View>
      )}
      <Flex flexDirection={isDesktop ? 'row' : 'column'}>
        {isDesktop && (
          <View width="40%" mr="32px" flexGrow={1}>
            <SecurityMask title="City" showAsterisk />
          </View>
        )}
        <View
          width={isDesktop ? '20%' : '30%'}
          minWidth="55px"
          mr={isDesktop ? '32px' : '20%'}
          mb={isDesktop ? '0' : '16px'}
          flexShrink={1}>
          <SecurityMask title="State" showAsterisk asteriskLength={2} />
        </View>
        <View width={isDesktop ? '20%' : '30%'} minWidth="55px" flexShrink={1}>
          <SecurityMask title="Zip Code" showAsterisk asteriskLength={5} />
        </View>
      </Flex>
    </View>
  );
};

export default GatedCityStateZip;
